import clsx from 'clsx';
import { Button, ButtonVariant } from '@clover/web-lib-consumer-ui';
import React, { FC } from 'react';
import styles from './CtaItem.module.scss';

const Primary: FC<React.ComponentProps<typeof Button>> = React.forwardRef((props, ref) => {
  return (
    <Button className={clsx(styles.primary, props.className)} ref={ref} {...props}>
      {props.children}
    </Button>
  );
});

const Secondary: FC<React.ComponentProps<typeof Button>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Button
      variant={ButtonVariant.INVERTED}
      className={clsx(styles.secondary, className)}
      {...props}
    >
      {children}
    </Button>
  );
};

const Custom: FC<React.ComponentProps<'div'>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(styles.custom, className)}
      {...props}
    >
      {children}
    </div>
  );
};

export const CtaItem = {
  Primary,
  Secondary,
  Custom
};

// eslint-disable-next-line import/no-default-export
export default CtaItem;
